var map = {
	"./bar.png": 79,
	"./basic.png": 80,
	"./cherub.png": 81,
	"./clown.png": 82,
	"./crystal.png": 83,
	"./fade.png": 84,
	"./falcon.png": 85,
	"./flaunt.png": 86,
	"./giraffe.png": 87,
	"./iridescent.png": 88,
	"./jaguar.png": 89,
	"./jupiter.png": 90,
	"./laced.png": 91,
	"./leopard.png": 92,
	"./lionfish.png": 93,
	"./metallic.png": 94,
	"./mosaic.png": 95,
	"./mosiac.png": 96,
	"./petals.png": 97,
	"./piebald.png": 98,
	"./pinstripe.png": 99,
	"./poison.png": 100,
	"./python.png": 101,
	"./ribbon.png": 102,
	"./ripple.png": 103,
	"./savannah.png": 104,
	"./skink.png": 105,
	"./slime.png": 106,
	"./speckle.png": 107,
	"./starmap.png": 108,
	"./stitched.png": 109,
	"./swirl.png": 110,
	"./tapir.png": 111,
	"./tiger.png": 112,
	"./vipera.png": 113,
	"./wasp.png": 114
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 78;